import React from 'react'

import { useTranslation } from 'react-i18next'

import portrait from '../../../assets/doctor-picture-cutted.jpg'
import { SectionText } from '../../../components/SectionText'
import { formatBreakline } from '../../../utils/HTML-breakline-converter'
interface Section1Props {
    className?: string
}

export const DoctorIntroduction: React.FC<Section1Props> = ({ className }) => {
    const { t } = useTranslation()
    return (
        <div
            className={`${className} flex items-center justify-center h-[1000px] w-full
            sm:max-h-[1700px] xxl:h-[1200px]
        `}>
            <div className="w-full h-full flex flex-col items-center justify-end relative">
                <img src={portrait} alt="Portrait von Herrn Kreuzer" className="h-full w-full absolute object-cover object-top" />
                <div
                    className="flex items-center justify-center bg-opacity-80 z-10 min-h-[400px] w-full bg-primary-green text-white
                    sm:px-3 sm:h-auto sm:min-h-[300px]
                ">
                    <SectionText
                        className="place-content-center max-w-[700px] h-full px-5 sm:py-5"
                        title={t('doctorIntroduction.title')}
                        hrLineColor="bg-primary-blue">
                        <div dangerouslySetInnerHTML={{ __html: formatBreakline(t('doctorIntroduction.description')) }} />
                    </SectionText>
                </div>
            </div>
        </div>
    )
}
